import {
  ADMIN_SEARCH_TYPES_LOADED,
  ADMIN_SEARCH_TYPES_CLEAR,
  ADMIN_COMPANY_FORM_FIELDS_LOADED,
  ADMIN_COMPANY_FORM_FIELDS_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  searchTypes: null,
  companyFormFields: null,
};

function adminSearches(state = initialState, action) {
  switch (action.type) {
    case ADMIN_SEARCH_TYPES_LOADED:
      return {
        ...state,
        searchTypes: action.payload.searchTypes,
      };
    case ADMIN_SEARCH_TYPES_CLEAR:
      return {
        ...state,
        searchTypes: null,
      };
    case ADMIN_COMPANY_FORM_FIELDS_LOADED:
      return {
        ...state,
        companyFormFields: action.payload.formFields,
      };
    case ADMIN_COMPANY_FORM_FIELDS_CLEAR:
      return {
        ...state,
        companyFormFields: null,
      };
    default:
      return state;
  }
}

export default adminSearches;
